"use client"
import { DropdownMenuItem } from "@/components/ui/dropdown-menu"
import {
	AlertDialog,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import { Button } from "@/components/ui/button"
import { FC, useState } from "react"
import { Trash2Icon } from "lucide-react"

interface Props {
	id: number;
	title?: string;
	description?: string;
	onConfirmDelete?: (id: number) => void;
}

const Delete: FC<Props> = ({ id, title, description, onConfirmDelete }) => {
	const [open, setOpen] = useState(false)
	const handleDeleteClick = (e: React.MouseEvent) => {
		e.preventDefault()
		e.stopPropagation()
		setOpen(true)
	}

	const confirmDelete = async () => {
		setOpen(false);
		onConfirmDelete?.(id);
	}

	return (
		<>
			<DropdownMenuItem onClick={handleDeleteClick}>
				<Trash2Icon className="mr-2 h-4 w-4 text-destructive" />
				{title || "Delete"}
			</DropdownMenuItem>

			<AlertDialog open={open} onOpenChange={setOpen}>
				<AlertDialogContent>
					<AlertDialogHeader>
						<AlertDialogTitle>{title || "Confirm"}</AlertDialogTitle>
						<AlertDialogDescription>
							{description || "Are you sure you want to delete this item? This action cannot be undone."}
						</AlertDialogDescription>
					</AlertDialogHeader>
					<AlertDialogFooter>
						<AlertDialogCancel onClick={() => setOpen(false)}>Cancel</AlertDialogCancel>
						<Button variant="destructive" onClick={confirmDelete} >
							Delete
						</Button>
					</AlertDialogFooter>
				</AlertDialogContent>
			</AlertDialog>
		</>
	)
}
export default Delete